import { render, staticRenderFns } from "./StarterPackDoctorMetrics.vue?vue&type=template&id=65070a36&scoped=true"
import script from "./StarterPackDoctorMetrics.vue?vue&type=script&lang=js"
export * from "./StarterPackDoctorMetrics.vue?vue&type=script&lang=js"
import style0 from "./StarterPackDoctorMetrics.vue?vue&type=style&index=0&id=65070a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65070a36",
  null
  
)

export default component.exports